import { FunctionComponent } from 'react'
import IconButton, { IconButtonComponentProps } from './IconButton'

const IconHelp: FunctionComponent<IconButtonComponentProps> = props => (
	<IconButton name="help" {...props}>
		<svg viewBox="0 0 100 100">
			<path d="M37.75 82.7q-.15 1.55-.15 4.55v2.25q0 5.45 2.25 7.7Q43 100 48.6 100q5.75 0 8.55-.85 2.65-.9 4.05-3.5 1.2-2.65 1.2-7.9 0-7.5-2.45-10.1-2.6-2.45-8.55-2.45-5.8 0-8.55.85-2.65.9-3.85 3-1.05 2.1-1.25 3.65m5.6-59.8q2.45-1.55 7.15-1.55 5.1 0 7.55 2.25 2.45 2.45 2.45 6.85 0 4.15-3.35 6.8-3.3 2.45-7.15 3.65-3.7 1.05-7 4.4-3.3 3.15-3.3 8.9l-.2 1.05q0 2.8.2 4 .35 1.25 1.2 2.8.9 1.6 3.3 2.3 2.3.7 6.15.7 3.85 0 6.1-.7 2.45-.55 3.5-1.95.9-1.4 1.05-2.6.2-1.2.2-3.5l2.25-.5q5.05-1.95 10.85-7.55 2.95-2.8 4.9-7.5 2.1-4.9 2.1-10.65 0-12.1-8.95-21Q63.45 0 49.45 0q-6.6 0-12.2 2.3Q32 4.4 28.85 7q-3 2.6-5.25 6.1-2.3 3.5-3 4.75-.5 1.4-1.2 3.5t-.7 4q0 4.55 7.85 7.7 4.2 1.55 6.65 1.55t4.05-1.7q1.75-1.95 2.95-5.25l.35-1.75q.55-1.6 2.8-3Z" />
		</svg>
	</IconButton>
)

export default IconHelp
